import type { UpCurrencyConfigEntry } from '../../../../../types/Configuration';

const DEFAULT_GROUPING_SEPARATOR = ',';

const forceAmount = (amount: string | number, currencyConfig: UpCurrencyConfigEntry | undefined): string => {
  if (!currencyConfig) {
    return `${amount}`;
  }

  const { decimalSeparator, groupingSeparator } = currencyConfig;

  const roundedAmount = `${amount}`;
  const roundedAmountWithDecimalSeparatorApplied = decimalSeparator
    ? roundedAmount.replace('.', decimalSeparator)
    : roundedAmount;

  const characterToInsertAsGroupingSeparator = groupingSeparator ?? DEFAULT_GROUPING_SEPARATOR;
  const spacesDetectedToApplyGroupingSeparator = /\B(?=(\d{3})+(?!\d))/g;

  return roundedAmountWithDecimalSeparatorApplied.replace(
    spacesDetectedToApplyGroupingSeparator,
    characterToInsertAsGroupingSeparator,
  );
};

export default forceAmount;
